import React from "react";
import UploadIcon from "@assets/images/NoSubscriptionAstronot.png";

const NoHistory = ({
  heading = "No Data Found",
  subheading = "There’s nothing to show yet. Keep going!",
  showSmallIcon = false,
}) => {
  return (
    <div className="bg-white rounded-[12px] flex flex-col justify-center items-center">
      <img
        src={UploadIcon}
        className={`border-[1px] border-solid border-white rounded-full p-1 max-w-[200px] ${
          showSmallIcon && "w-[100px]"
        }`}
        alt="Upload icon"
      />
      <h2 className="text-[24px] font-[700] text-[#303030] text-center font-Lato">
        {heading}
      </h2>
      <p className="text-[#6C6C6C] text-[16px] font-Lato text-center my-2 max-w-[80%]">
        {subheading}
      </p>
    </div>
  );
};

export default NoHistory;
